import { Link, useLocation } from "react-router-dom";
import { GitCompareArrows, X } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useCompare, MAX_COMPARE } from "@/lib/compare";

export const CompareToggle = ({ id, className = "" }) => {
  const { t } = useLang();
  const { has, toggle } = useCompare();
  const on = has(id);
  return (
    <button type="button" data-testid={`compare-toggle-${id}`} onClick={() => toggle(id, t("compare_full"))} title={t("compare")}
      className={`inline-flex items-center gap-1.5 text-xs font-mono-x uppercase tracking-wider transition-colors ${on ? "text-orange-400" : "text-slate-500 hover:text-slate-200"} ${className}`}>
      <GitCompareArrows className="w-4 h-4" /> {on ? t("compare_added") : t("compare")}
    </button>
  );
};

export function CompareBar() {
  const { t } = useLang();
  const { ids, clear } = useCompare();
  const { pathname } = useLocation();
  if (!ids.length || pathname === "/compare") return null;
  return (
    <div data-testid="compare-bar" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-3 border border-orange-500/60 bg-[#292D3C]/90 backdrop-blur-md px-4 py-3 shadow-2xl">
      <GitCompareArrows className="w-5 h-5 text-orange-500" />
      <span className="text-sm text-slate-200 whitespace-nowrap">{t("compare")}: <span data-testid="compare-count" className="font-mono-x">{ids.length}/{MAX_COMPARE}</span></span>
      <Link to="/compare" data-testid="compare-bar-open" className="h-9 px-4 inline-flex items-center bg-orange-500 text-[#1F2230] font-display font-bold uppercase tracking-widest text-sm hover:bg-orange-400 transition-colors">{t("compare_open")}</Link>
      <button data-testid="compare-bar-clear" onClick={clear} title={t("compare_clear")} className="text-slate-500 hover:text-red-400"><X className="w-4 h-4" /></button>
    </div>
  );
}
